import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UserModel } from '@core/api/model/userModel';
import { TransportModel } from '@core/api/model/transportModel';
import { I18n } from '@ngx-translate/i18n-polyfill';
import {UserService} from '@core/api';

export interface DialogData {
  user: UserModel;
  transport: TransportModel
}

@Component({
  selector: 'user-modal-terms',
  templateUrl: './modal-terms.component.html',
  styleUrls: ['./modal-terms.component.scss']
})
export class ModalTermsComponent implements OnInit, OnDestroy {
  accepted: boolean;
  user: UserModel;

  constructor(
    private i18n: I18n,
    private apiUserService: UserService,
    public dialogRef: MatDialogRef<ModalTermsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData)
  {
    this.user = data.user;
  }

  submit() {
    if (this.user.applied_terms) {
      this.apiUserService
        .userIdApplyTermsPost(this.user.id, {applied_terms: this.user.applied_terms})
        .subscribe((data) => {
          this.dialogRef.close(true);
        });
    }
  }

  ngOnDestroy() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
